import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ReviewAnalysisApiService } from 'src/services/reviewAnalysisApi'
import { ReviewAnalysisDateRange } from 'src/services/reviewAnalysisApi/interfaces/reviewAnalysis.interface'

export const useGetReviewAnalysisOverviewQuery = (
  campaignId: string,
  range?: ReviewAnalysisDateRange
) =>
  useQuery({
    enabled: !!campaignId,
    queryFn: () => ReviewAnalysisApiService.getOverview(campaignId, range),
    queryKey: [
      QueryKey.GET_REVIEW_ANALYSIS_OVERVIEW,
      campaignId,
      range?.from ?? '',
      range?.to ?? '',
    ],
  })
